import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Img from "../../../images/locationgcc/qa/experienced.webp";

function Banner(props) {
  return (
    <div className="experienced p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Craft a Robust Mobile App for Your Business with Our App
              Developers in Qatar
            </h2>
            <p>
              TekRevol is a group of creative and marketing professionals who
              believe in an innovation-driven approach to continuously
              revolutionize business with its optimal app solutions. Our goal is
              to provide top-tier development and enterprise consultancy
              services against the backdrop of the competitive GCC market,
              especially in Qatar.
            </p>
            <p>
              To ensure the best outcome, our mobile app development company
              hires only the top 1% of app developers. Therefore, you can trust
              our credibility in this field as an epitome of our commitment to
              delivering promising solutions. They remain selective in choosing
              the right technology that is the best for your project needs.
              Further, our developers utilize their expertise to craft seamless
              applications with quality performance.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Get Started
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <LazyLoadImage
              src={Img}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
